module.exports = 0;



// WEBPACK FOOTER //
// ./lib/values/expires-now.js